module.exports = __webpack_public_path__ + "img/fastvaluedeal-money-back-guarantee.d8db3a6b.png";